const withName = name => prevProjectOrTemplate => ({
    ...prevProjectOrTemplate,
    name,
});

export default withName;
